import request from '../request';
// 清空
export const emptyDeletedCvs = (axios, params) => {
  return request({
    url: '/v3/hidden_cvs',
    method: 'delete',
    data: params
  })
}
// 列表
export const getDeletedList = (axios, params) => {
  return request({
    url: '/v3/hidden_cvs',
    method: 'get'
  })
}
// 恢复
export const recoveryCv = (axios, params, token) => {
  return request({
    url: `/v3/hidden_cvs/${token}`,
    method: 'put',
    data: params
  })
}
// 删除
export const deleteCv = (axios, params, token) => {
  return request({
    url: `/v3/hidden_cvs/${token}`,
    method: 'delete',
    data: params
  })
}